import React, { useEffect } from "react";
import "./ToastHost.css";

export default function ToastHost({ toast, onClear }) {
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => onClear?.(), 2600);
    return () => clearTimeout(t);
  }, [toast, onClear]);

  if (!toast) return null;
  const cls = "aaToast " + (toast.kind || "info");
  return (
    <div className="aaToastWrap">
      <div className={cls}>
        <div className="aaToastMsg">{toast.msg || ""}</div>
      </div>
    </div>
  );
}
